import React, { ChangeEventHandler, FocusEventHandler } from "react";
import InputWrapper from "./input-wrapper";

export interface TextboxProps {
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  name: string;
  label: string;
  type?: string;
  helpNote?: string;
  defaultValue?: string | number | readonly string[];
  disabled?: boolean;
  className?: string;
  required?: boolean;
  errorMessage?: string;
}

const Textbox = React.forwardRef<HTMLInputElement, TextboxProps>(
  (
    {
      onChange,
      onBlur,
      name,
      label,
      helpNote,
      defaultValue,
      disabled,
      type = "text",
      className,
      required = false,
      errorMessage,
    },
    ref
  ) => {
    return (
      <InputWrapper label={label} helpNote={helpNote}>
        <input
          defaultValue={defaultValue}
          type={type}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          ref={ref}
          disabled={disabled}
          required={required}
          className={`w-full sm:w-full border rounded-lg px-3 py-2 text-sm focus:outline-none disabled:bg-gray-100 ${
            errorMessage ? "border-red-500" : "border-gray-300"
          } ${className || ""}`}
        />

        {errorMessage && (
          <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
        )}
      </InputWrapper>
    );
  }
);

Textbox.displayName = "Textbox";

export default Textbox;
